import {InjectionToken} from '@angular/core'

export const WINDOW = new InjectionToken<Window>('window')
export const LOCAL_STORAGE = new InjectionToken<Storage>('storage')